import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "offline-backdrop" }
const _hoisted_2 = { class: "offline-select-container" }
const _hoisted_3 = { class: "offline-select-header" }
const _hoisted_4 = { class: "offline-progress-container" }
const _hoisted_5 = { class: "offline-progress-text" }
const _hoisted_6 = { class: "offline-progress-container" }
const _hoisted_7 = { class: "offline-progress-text" }
const _hoisted_8 = { class: "offline-progress-container" }
const _hoisted_9 = { class: "offline-progress-text" }
const _hoisted_10 = {
  class: "release-page-container",
  style: {"margin-top":"5em"}
}
const _hoisted_11 = { class: "release-page-background" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "release-info-container" }
const _hoisted_14 = { class: "release-program-name" }
const _hoisted_15 = { class: "release-number" }
const _hoisted_16 = { class: "media-buttons" }
const _hoisted_17 = { class: "release-settings-card-container bg-transparent" }
const _hoisted_18 = { class: "release-settings-btn-container" }
const _hoisted_19 = { class: "release-settings-card-container bg-transparent" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "release-settings-btn-container" }
const _hoisted_26 = { class: "release-settings-card-container bg-transparent" }
const _hoisted_27 = {
  key: 0,
  class: "video-status-hint"
}
const _hoisted_28 = { class: "single-video-progress-container" }
const _hoisted_29 = {
  slot: "end",
  class: "video-select-actions"
}
const _hoisted_30 = { class: "release-settings-btn-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_toast = _resolveComponent("ion-toast")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
            [_vShow, _ctx.showOfflineSelector]
          ]),
          _cache[48] || (_cache[48] = _createElementVNode("div", { class: "top-safe-area" }, null, -1)),
          _createVNode(_component_ion_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returnBack(_ctx.prevRouteName))),
            class: "header-sm-button bg-transparent top-level white-regular"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                icon: _ctx.arrowBackOutline
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.returnBack('Showcase'))),
            class: "header-sm-button header-sm-button-right bg-transparent top-level white-regular"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "end",
                icon: _ctx.homeOutline
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_list, { lines: "none" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives(_createVNode(_component_ion_icon, {
                    icon: _ctx.close,
                    class: "close-icon",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideOfflineSelector()))
                  }, null, 8, ["icon"]), [
                    [_vShow, !_ctx.isDownloading]
                  ])
                ]),
                _createVNode(_component_ion_list_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                        _createTextVNode("Оффлайн доступ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  class: _normalizeClass([
            'online-item',
            _ctx.releaseEntity.musicOffline &&
              !_ctx.downloadProgress.get('music')?.downloading &&
              !_ctx.preparingDownload.get('music')
              ? 'offline-item'
              : '',
          ]),
                  button: "",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleEntityClick('music'))),
                  disabled: _ctx.downloadProgress.get('music')?.downloading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                        _createTextVNode("Музыка", -1)
                      ]))]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_ion_text, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.downloadProgress.get("music")?.percentage) + "% ", 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.downloadProgress.get('music')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_spinner, {
                      slot: "end",
                      name: "crescent"
                    }, null, 512), [
                      [_vShow, _ctx.preparingDownload.get('music') && !_ctx.downloadProgress.get('music')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.cloudDownloadOutline,
                      slot: "end"
                    }, null, 8, ["icon"]), [
                      [_vShow, !_ctx.releaseEntity.musicOffline &&
              !_ctx.downloadProgress.get('music')?.downloading &&
              !_ctx.preparingDownload.get('music')
              ]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.stopCircle,
                      slot: "end",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.stopDownload('music')), ["stop"]))
                    }, null, 8, ["icon"]), [
                      [_vShow, _ctx.downloadProgress.get('music')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.trash,
                      slot: "end",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.removeReleaseEntityDirectory('music')), ["stop"]))
                    }, null, 8, ["icon"]), [
                      [_vShow, !_ctx.downloadProgress.get('music')?.downloading &&
              !_ctx.preparingDownload.get('music') &&
              _ctx.releaseEntity.musicOffline
              ]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "offline-progress-bottom",
                        style: _normalizeStyle({
                width: `${_ctx.downloadProgress.get('music')?.percentage || 0}%`,
              })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatFileSize(_ctx.downloadProgress.get('music')?.downloaded || 0)), 1)
                    ], 512), [
                      [_vShow, _ctx.downloadProgress.get('music')?.downloading]
                    ])
                  ]),
                  _: 1
                }, 8, ["class", "disabled"]),
                _createVNode(_component_ion_item, {
                  class: _normalizeClass([
            'online-item',
            _ctx.releaseEntity.videoOffline &&
              !_ctx.downloadProgress.get('video')?.downloading &&
              !_ctx.preparingDownload.get('video')
              ? 'offline-item'
              : '',
          ]),
                  button: "",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleEntityClick('video'))),
                  disabled: _ctx.downloadProgress.get('video')?.downloading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                        _createTextVNode("Видео", -1)
                      ]))]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_ion_text, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.downloadProgress.get("video")?.percentage) + "% ", 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.downloadProgress.get('video')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_spinner, {
                      slot: "end",
                      name: "crescent"
                    }, null, 512), [
                      [_vShow, _ctx.preparingDownload.get('video') && !_ctx.downloadProgress.get('video')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.cloudDownloadOutline,
                      slot: "end"
                    }, null, 8, ["icon"]), [
                      [_vShow, !_ctx.releaseEntity.videoOffline &&
              !_ctx.downloadProgress.get('video')?.downloading &&
              !_ctx.preparingDownload.get('video')
              ]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.stopCircle,
                      slot: "end",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.stopDownload('video')), ["stop"]))
                    }, null, 8, ["icon"]), [
                      [_vShow, _ctx.downloadProgress.get('video')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.trash,
                      slot: "end",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.removeReleaseEntityDirectory('video')), ["stop"]))
                    }, null, 8, ["icon"]), [
                      [_vShow, !_ctx.downloadProgress.get('video')?.downloading &&
              !_ctx.preparingDownload.get('video') &&
              _ctx.releaseEntity.videoOffline
              ]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: "offline-progress-bottom",
                        style: _normalizeStyle({
                width: `${_ctx.downloadProgress.get('video')?.percentage || 0}%`,
              })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatFileSize(_ctx.downloadProgress.get('video')?.downloaded || 0)), 1)
                    ], 512), [
                      [_vShow, _ctx.downloadProgress.get('video')?.downloading]
                    ])
                  ]),
                  _: 1
                }, 8, ["class", "disabled"]),
                _createVNode(_component_ion_item, {
                  class: _normalizeClass([
            'online-item',
            _ctx.releaseEntity.guideOffline &&
              !_ctx.downloadProgress.get('guide')?.downloading &&
              !_ctx.preparingDownload.get('guide')
              ? 'offline-item'
              : '',
          ]),
                  button: "",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleEntityClick('guide'))),
                  disabled: _ctx.downloadProgress.get('guide')?.downloading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                        _createTextVNode("Гайд", -1)
                      ]))]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_ion_text, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.downloadProgress.get("guide")?.percentage) + "% ", 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.downloadProgress.get('guide')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_spinner, {
                      slot: "end",
                      name: "crescent"
                    }, null, 512), [
                      [_vShow, _ctx.preparingDownload.get('guide') && !_ctx.downloadProgress.get('guide')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.cloudDownloadOutline,
                      slot: "end"
                    }, null, 8, ["icon"]), [
                      [_vShow, !_ctx.releaseEntity.guideOffline &&
              !_ctx.downloadProgress.get('guide')?.downloading &&
              !_ctx.preparingDownload.get('guide')
              ]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.stopCircle,
                      slot: "end",
                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.stopDownload('guide')), ["stop"]))
                    }, null, 8, ["icon"]), [
                      [_vShow, _ctx.downloadProgress.get('guide')?.downloading]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.trash,
                      slot: "end",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.removeReleaseEntityDirectory('guide')), ["stop"]))
                    }, null, 8, ["icon"]), [
                      [_vShow, !_ctx.downloadProgress.get('guide')?.downloading &&
              !_ctx.preparingDownload.get('guide') &&
              _ctx.releaseEntity.guideOffline
              ]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        class: "offline-progress-bottom",
                        style: _normalizeStyle({
                width: `${_ctx.downloadProgress.get('guide')?.percentage || 0}%`,
              })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatFileSize(_ctx.downloadProgress.get('guide')?.downloaded || 0)), 1)
                    ], 512), [
                      [_vShow, _ctx.downloadProgress.get('guide')?.downloading]
                    ])
                  ]),
                  _: 1
                }, 8, ["class", "disabled"])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.showOfflineSelector]
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: _ctx.releaseCoverSrc,
                alt: "program page",
                ref: "programImageRef"
              }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.releaseEntity.programName), 1),
              _createElementVNode("div", _hoisted_15, "Релиз " + _toDisplayString(_ctx.releaseEntity.release), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_ion_button, {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openReleaseDetail('ReleaseMusic'))),
                class: "media-button",
                disabled: _ctx.isDownloading ||
            (!_ctx.releaseEntity.musicOffline && _ctx.globalContext.offlineMode)
            
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.musicalNotesOutline }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_ion_button, {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openReleaseDetail('ReleaseVideo'))),
                class: "media-button media-button-middle",
                disabled: _ctx.isDownloading
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.filmOutline }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_ion_button, {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openReleaseDetail('ReleaseGuide'))),
                class: "media-button",
                disabled: _ctx.isDownloading ||
            (!_ctx.releaseEntity.guideOffline && _ctx.globalContext.offlineMode)
            
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.documentOutline }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['bottom-buttons-container', _ctx.isLandscapeMode ? 'bottom-buttons-container-landscape' : ''])
          }, [
            _withDirectives(_createVNode(_component_ion_button, {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showOfflineSelector = true)),
              class: "download-button"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.cloudDownload }, null, 8, ["icon"]), [
                  [_vShow, !_ctx.releaseEntity.musicOffline || !_ctx.releaseEntity.videoOffline
            ]
                ]),
                _withDirectives(_createVNode(_component_ion_label, { class: "ion-margin-start" }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                    _createTextVNode("Загрузить оффлайн", -1)
                  ]))]),
                  _: 1
                }, 512), [
                  [_vShow, !_ctx.releaseEntity.musicOffline || !_ctx.releaseEntity.videoOffline
            ]
                ]),
                _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.cloudDone }, null, 8, ["icon"]), [
                  [_vShow, _ctx.releaseEntity.musicOffline &&
            _ctx.releaseEntity.videoOffline &&
            _ctx.releaseEntity.guideOffline
            ]
                ]),
                _withDirectives(_createVNode(_component_ion_label, { class: "ion-margin-start" }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode("Доступно оффлайн", -1)
                  ]))]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.releaseEntity.musicOffline && _ctx.releaseEntity.videoOffline]
                ])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_ctx.isDownloading && !_ctx.globalContext.offlineMode && _ctx.isMobile]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['admin-buttons', _ctx.isLandscapeMode ? 'admin-buttons-landscape' : ''])
            }, [
              _withDirectives(_createVNode(_component_ion_button, {
                class: "download-button",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changeReleaseVisibility(!_ctx.releaseVisible)))
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.eye }, null, 8, ["icon"]), [
                    [_vShow, !_ctx.releaseVisible]
                  ]),
                  _withDirectives(_createVNode(_component_ion_label, { class: "ion-margin-start" }, {
                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                      _createTextVNode("Опубликовать", -1)
                    ]))]),
                    _: 1
                  }, 512), [
                    [_vShow, !_ctx.releaseVisible]
                  ]),
                  _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.eyeOff }, null, 8, ["icon"]), [
                    [_vShow, _ctx.releaseVisible]
                  ]),
                  _withDirectives(_createVNode(_component_ion_label, { class: "ion-margin-start" }, {
                    default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                      _createTextVNode("Скрыть", -1)
                    ]))]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.releaseVisible]
                  ])
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.globalContext.isManager && !_ctx.globalContext.offlineMode]
              ]),
              _withDirectives(_createVNode(_component_ion_button, {
                class: "download-button",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openReleaseSetting()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.settings }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, { class: "ion-margin-start" }, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                      _createTextVNode("Настройки", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.globalContext.isManager && !_ctx.globalContext.offlineMode]
              ])
            ], 2)
          ], 2),
          _createVNode(_component_ion_modal, {
            "can-dismiss": true,
            onDidDismiss: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showReleaseSettings = false)),
            "is-open": _ctx.showReleaseSettings,
            class: "release-settings-modal"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                            _createTextVNode("Настройки", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                _createTextVNode("Кеш аудио", -1)
                              ]))]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_ion_icon, {
                              icon: _ctx.reload,
                              slot: "end",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.reloadAudioCache()))
                            }, null, 8, ["icon"]), [
                              [_vShow, !_ctx.cacheReloadProgress.get('music')?.downloading]
                            ]),
                            _withDirectives(_createVNode(_component_ion_label, { slot: "end" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(Math.round(
                    ((_ctx.cacheReloadProgress.get("music")?.currentValue || 0) /
                      (_ctx.cacheReloadProgress.get("music")?.maxValue || 1)) *
                    100
                  )) + "%", 1)
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.cacheReloadProgress.get('music')?.downloading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                _createTextVNode("Кеш видео", -1)
                              ]))]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_ion_icon, {
                              icon: _ctx.reload,
                              slot: "end",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.reloadVideoCache()))
                            }, null, 8, ["icon"]), [
                              [_vShow, !_ctx.cacheReloadProgress.get('video')?.downloading]
                            ]),
                            _withDirectives(_createVNode(_component_ion_label, { slot: "end" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(Math.round(
                    ((_ctx.cacheReloadProgress.get("video")?.currentValue || 0) /
                      (_ctx.cacheReloadProgress.get("video")?.maxValue || 1)) *
                    100
                  )) + "%", 1)
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.cacheReloadProgress.get('video')?.downloading]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showReleaseSettings = false)),
                        disabled: _ctx.cacheReloadProgress.get('video')?.downloading ||
                  _ctx.cacheReloadProgress.get('music')?.downloading
                  
                      }, {
                        default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                          _createTextVNode(" Закрыть ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "can-dismiss": true,
            onDidDismiss: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showVideoDownloadDialog = false)),
            "is-open": _ctx.showVideoDownloadDialog,
            class: "video-download-modal"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                            _createTextVNode("Выберите режим загрузки", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "none",
                          button: "",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.downloadAllVideos()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.cloudDownload,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _cache[43] || (_cache[43] = _createElementVNode("h2", null, "Загрузить все видео", -1)),
                                (_ctx.getDownloadedVideosCount() === 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Загрузить все " + _toDisplayString(_ctx.videoList.length) + " видео файлов ", 1))
                                  : (_ctx.getDownloadedVideosCount() < _ctx.videoList.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Загрузить все видео (скачано: " + _toDisplayString(_ctx.getDownloadedVideosCount()) + "/" + _toDisplayString(_ctx.videoList.length) + ") ", 1))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_22, " Перезагрузить все " + _toDisplayString(_ctx.videoList.length) + " видео файлов ", 1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          lines: "none",
                          button: "",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showVideoSelectDialogHandler()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.cloudDownloadOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _cache[44] || (_cache[44] = _createElementVNode("h2", null, "Выбрать видео", -1)),
                                (_ctx.getDownloadedVideosCount() === 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Выбрать отдельные видео для загрузки "))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_24, " Выбрать видео (скачано: " + _toDisplayString(_ctx.getDownloadedVideosCount()) + "/" + _toDisplayString(_ctx.videoList.length) + ") ", 1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showVideoDownloadDialog = false))
                      }, {
                        default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "can-dismiss": true,
            onDidDismiss: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showVideoSelectDialog = false)),
            "is-open": _ctx.showVideoSelectDialog,
            class: "video-select-modal"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                            _createTextVNode("Выберите видео", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, { class: "video-select-content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (video) => {
                              return (_openBlock(), _createBlock(_component_ion_item, {
                                key: video.id,
                                class: _normalizeClass(['video-select-item', _ctx.isVideoOffline(video.id) ? 'offline-item' : '', _ctx.isVideoDownloading(video.id) ? 'downloading-item' : ''])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.formatVideoName(video.name)), 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.getVideoStatus(video.id)), 1),
                                      (!_ctx.isVideoOffline(video.id) && !_ctx.isVideoDownloading(video.id))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, " Не скачано "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _withDirectives(_createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", {
                                      class: "single-video-progress-bar",
                                      style: _normalizeStyle({
                      width: `${_ctx.singleVideoProgress.get(video.id)?.percentage || 0}%`,
                    })
                                    }, null, 4)
                                  ], 512), [
                                    [_vShow, _ctx.isVideoDownloading(video.id)]
                                  ]),
                                  _createElementVNode("div", _hoisted_29, [
                                    _withDirectives(_createVNode(_component_ion_icon, {
                                      icon: _ctx.cloudDone,
                                      class: "video-select-icon"
                                    }, null, 8, ["icon"]), [
                                      [_vShow, _ctx.isVideoOffline(video.id) && !_ctx.isVideoDownloading(video.id)]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_icon, {
                                      icon: _ctx.cloudDownloadOutline,
                                      class: "video-select-icon",
                                      onClick: ($event: any) => (_ctx.downloadSingleVideo(video))
                                    }, null, 8, ["icon", "onClick"]), [
                                      [_vShow, !_ctx.isVideoOffline(video.id) && !_ctx.isVideoDownloading(video.id)]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_icon, {
                                      icon: _ctx.stopCircle,
                                      class: "video-select-icon",
                                      onClick: ($event: any) => (_ctx.stopVideoDownload(video))
                                    }, null, 8, ["icon", "onClick"]), [
                                      [_vShow, _ctx.isVideoDownloading(video.id)]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_icon, {
                                      icon: _ctx.trash,
                                      class: "video-select-icon",
                                      onClick: ($event: any) => (_ctx.removeSingleVideo(video))
                                    }, null, 8, ["icon", "onClick"]), [
                                      [_vShow, _ctx.isVideoOffline(video.id) && !_ctx.isVideoDownloading(video.id)]
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createVNode(_component_ion_button, {
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.downloadRemainingVideos())),
                        fill: "outline",
                        class: "download-remaining-button"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.cloudDownload,
                            slot: "start"
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Загрузить оставшиеся (" + _toDisplayString(_ctx.getRemainingVideosCount()) + ") ", 1)
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.hasRemainingVideos() && !_ctx.downloadProgress.get('video')?.downloading]
                      ]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showVideoSelectDialog = false))
                      }, {
                        default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                          _createTextVNode(" Закрыть ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_toast, {
            cssClass: "custom-toast",
            "is-open": _ctx.isDownloading,
            message: "Не закрывайте приложение и окно до завершения процесса",
            position: "top",
            color: "dark"
          }, null, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}